$(document).on('click', '.copy-url', (event) => {
  event.preventDefault()
  // currentTarget: a click on the icon inside the button has the <svg> as target
  var url = event.currentTarget.dataset["url"]
  var tempInput =  $("<textarea>");
  $("body").append(tempInput);
  tempInput.val(url).select();
  document.execCommand("copy");
  tempInput.remove();

  $(event.currentTarget).addClass('copied')
  setTimeout(() => $(event.currentTarget).removeClass('copied'), 1500)
})
